import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mapbox/mr-ui/icon';
import { ActionCreators } from '../redux/action-creators';
import { util } from '@mapbox/gazetteer';
import Cartocam from '../../public/carto-cam.svg';

class Intro extends React.PureComponent {
  fileInputRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      messagingForBlogReferrer: document.referrer.match(
        /^https:\/\/blog.mapbox.com\/carto-cam/
      ),
      error: null
    };

    this.onUpload = this.onUpload.bind(this);
  }

  onUpload(e) {
    if (!e.target.files.length) return;

    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = e => {
      try {
        const geojson = JSON.parse(e.target.result);
        const invalidLocations = util.lintGazetteer(geojson);
        if (invalidLocations.length) {
          return this.setState({ error: invalidLocations.join(', ') });
        }

        this.setState(
          {
            error: null
          },
          () => ActionCreators.createFromExisting(geojson)
        );
      } catch (e) {
        return this.setState({ error: 'Error parsing GeoJSON' });
      }
    };

    reader.readAsText(file);
  }

  dismissBanner = () => {
    this.setState({ messagingForBlogReferrer: null });
  };

  recover = () => {
    ActionCreators.home(false);
  };

  createNew = () => {
    ActionCreators.createNew();
  };

  triggerFileInput = () => {
    this.fileInputRef.current.click();
  };

  render() {
    const { error, messagingForBlogReferrer } = this.state;
    const { geojson } = this.props;
    const recover = !!geojson.features.length;
    let banner;

    if (messagingForBlogReferrer) {
      banner = (
        <div className="fixed w-full bg-white border-b border--gray-light px12 align-center py12 txt-m z5">
          👋 Carto-cam is now a tool for creating &amp; managing
          <a
            className="link link--gray-light ml6"
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/mapbox/gazetteer"
          >
            Gazetteers
          </a>
          .
        </div>
      );
    }

    return (
      <div className="viewport-full">
        {banner}
        <div className="flex-parent flex-parent--center-cross flex-parent--center-main h-full">
          <div className="flex-child align-center mt-neg120">
            <div className="mb24 mx-auto">
              <Cartocam />
            </div>
            <h2 className="txt-h2 txt-fancy">Carto cam</h2>
            <h4 className="txt-l color-gray">
              Create & manage{' '}
              <a
                className="link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://github.com/mapbox/gazetteer"
              >
                Gazetteers
              </a>
            </h4>
            {error && (
              <div className="my12">
                <div className="bg-orange-faint color-orange-dark border border--orange round px12 py6 txt-s wmax360 mx-auto hmax120 scroll-auto scroll-styled">
                  {error}
                </div>
              </div>
            )}
            <div className="mt12">
              <button
                test="upload"
                onClick={this.triggerFileInput}
                className="txt-s px24 btn btn--stroke btn--gray mr6"
              >
                <span className="flex-parent flex-parent--center-cross">
                  <span className="flex-child mr3">
                    <Icon name="harddrive" inline={true} />
                  </span>
                  <span className="flex-child">Choose existing</span>
                </span>
              </button>
              <input
                ref={this.fileInputRef}
                onChange={this.onUpload}
                type="file"
                className="w0 h0"
                accept="application/JSON"
                style={{ zIndex: -1 }}
              />
              <button
                test="create"
                onClick={this.createNew}
                className="txt-s px24 btn"
              >
                Create new
              </button>
            </div>
            {recover && (
              <div className="align-center mt12">
                <button
                  test="recover"
                  onClick={this.recover}
                  className="txt-s link link--gray"
                >
                  Recover from last edit?
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

Intro.propTypes = {
  geojson: PropTypes.object.isRequired
};

export { Intro };
